import Bloom from "../common/Bloom";
import "./Hero.css";

function Hero() {
  return (
    <section className="hero-new">
      <div className="hero-new-side hero-new-side--left" aria-hidden="true">
        DTC Consultant
      </div>
      <div className="hero-new-side hero-new-side--right" aria-hidden="true">
        Coastal Division
      </div>

      <div className="hero-new-pills">
        <span className="hero-new-pill">DTC Growth &middot; Ecommerce</span>
        <span className="hero-new-pill">Shopify Plus &middot; Brand Strategy</span>
      </div>

      <Bloom className="hero-new-bloom" />

      <div className="hero-new-container">
        <h1 className="hero-new-title">
          Weston<br />Brown
        </h1>
      </div>

      <div className="hero-new-meta">
        <span>Coastal Division</span>
        <span>DTC &#10035; Ecommerce</span>
        <span>10+ Years</span>
      </div>
    </section>
  );
}

export default Hero;
